export const dialogTitleStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 22,
    fontWeight: 500
};

export const dialogPropertyNameStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 18,
    fontWeight: 500
};

export const dialogTableStyle = {
    width: '100%',
    borderCollapse: 'collapse'
};

export const dialogTableCellStyle = (i, first = false, last = false) => {
    return {
        boxSizing: 'border-box',
        height: 29,
        width: 260,
        border: '1px solid #D7D7D7',
        borderRadius: `${first ? '5px' : '0'} 0 0 ${last ? '5px' : '0'}`,
        backgroundColor: i % 2 === 0 ? '#F7F7F7' : '#FFFFFF'
    };
};

export const dialogCellTitleStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500,
    paddingLeft: 8
};

export const dialogCellValueStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 400,
    paddingLeft: 8
};

export const labelStyle = {
    display: 'block',
    textAlign: 'left',
    fontSize: 12,
    color: '#414141',
    marginBottom: 5
};

export const sectionTitleStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 'bold'
};

export const showTitleStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 17,
    fontWeight: 'bold'
};
